import { downloadCsv } from "./csv";

/** Download a CSV template with headers + sample rows. */
export function downloadCsvTemplate(filename, rows) {
  downloadCsv(filename, rows);
}

/** Registration bulk-upload columns (matches /api/registrations/bulk-upload). */
export const REGISTRATION_UPLOAD_SAMPLE = [
  {
    email: "student.full@example.com",
    name: "Full Fee Student",
    phone: "923001112233",
    city: "Lahore",
    feemode: "full",
    courseId: 6,
  },
  {
    email: "student.partial@example.com",
    name: "Partial Fee Student",
    phone: "923009998877",
    city: "Karachi",
    feemode: "partial",
    courseId: 6,
  },
];

/**
 * User bulk-upload columns (matches /api/users/bulk-upload).
 * Upload users first — registration CSV requires the email to exist in Users
 * (unless the registration upload creates a minimal user row).
 */
export const USER_UPLOAD_SAMPLE = [
  {
    email: "student@example.com",
    name: "Student Name",
    phoneNumber: "923001112233",
    parentsPhoneNumber: "923009998877",
    address: "Street 12, Block A",
    city: "Lahore",
    province: "Punjab",
    country: "Pakistan",
    school: "Beaconhouse",
    grade: "Grade 10",
  },
  {
    email: "student2@example.com",
    name: "Another Student",
    phoneNumber: "923001234567",
    parentsPhoneNumber: "923007654321",
    address: "House 5, Sector G",
    city: "Islamabad",
    province: "Islamabad Capital Territory",
    country: "Pakistan",
    school: "Roots Millennium",
    grade: "A Levels",
  },
];

/** Topic bulk-upload columns (matches /api/topics/bulk-upload). */
export const TOPIC_UPLOAD_SAMPLE = [
  {
    gradeId: 1,
    subjectId: 1,
    topicName: "Algebra Basics",
    weightage: 1,
  },
  {
    gradeId: 1,
    subjectId: 1,
    topicName: "Quadratic Equations",
    weightage: 3,
  },
  {
    gradeId: 2,
    subjectId: 1,
    topicName: "Trigonometry Intro",
    weightage: "",
  },
];

/**
 * Lecture bulk-upload columns (matches /api/lectures/bulk-upload).
 * Prefer topicId when known; topicName is used only when topicId is blank.
 * If both are present, topicId wins (still must match gradeId + subjectId).
 */
export const LECTURE_UPLOAD_SAMPLE = [
  {
    gradeId: 1,
    subjectId: 1,
    topicId: "",
    topicName: "Algebra Basics",
    url: "https://www.youtube.com/watch?v=example1",
    description: "Resolve by topicName when topicId is empty",
  },
  {
    gradeId: 1,
    subjectId: 1,
    topicId: 12,
    topicName: "",
    url: "https://www.youtube.com/watch?v=example2",
    description: "Resolve by topicId only",
  },
  {
    gradeId: 1,
    subjectId: 1,
    topicId: 12,
    topicName: "Algebra Basics",
    url: "https://www.youtube.com/watch?v=example3",
    description: "Both present — topicId is preferred",
  },
];

/** Note bulk-upload columns (matches /api/notes/bulk-upload). */
export const NOTE_UPLOAD_SAMPLE = [
  {
    gradeId: 1,
    subjectId: 1,
    topicId: "",
    topicName: "Algebra Basics",
    url: "https://drive.google.com/file/d/example-notes-1/view",
    description: "Resolve by topicName when topicId is empty",
  },
  {
    gradeId: 1,
    subjectId: 1,
    topicId: 12,
    topicName: "",
    url: "https://drive.google.com/file/d/example-notes-2/view",
    description: "Resolve by topicId only",
  },
  {
    gradeId: 1,
    subjectId: 1,
    topicId: 12,
    topicName: "Algebra Basics",
    url: "https://drive.google.com/file/d/example-notes-3/view",
    description: "Both present — topicId is preferred",
  },
];

/**
 * Worksheet bulk-upload columns (matches /api/worksheets/bulk-upload).
 * solutionUrl / solutionDescription are optional; blank solution is allowed.
 */
export const WORKSHEET_UPLOAD_SAMPLE = [
  {
    gradeId: 1,
    subjectId: 1,
    topicId: "",
    topicName: "Algebra Basics",
    worksheetUrl: "https://drive.google.com/file/d/ws-by-name/view",
    sheetDescription: "Resolve by topicName — with solution",
    solutionUrl: "https://drive.google.com/file/d/sol-by-name/view",
    solutionDescription: "",
  },
  {
    gradeId: 1,
    subjectId: 1,
    topicId: 12,
    topicName: "",
    worksheetUrl: "https://drive.google.com/file/d/ws-by-id/view",
    sheetDescription: "Resolve by topicId — worksheet only (no solution)",
    solutionUrl: "",
    solutionDescription: "",
  },
  {
    gradeId: 1,
    subjectId: 1,
    topicId: 12,
    topicName: "Algebra Basics",
    worksheetUrl: "https://drive.google.com/file/d/ws-both/view",
    sheetDescription: "Both topicId and topicName — topicId preferred",
    solutionUrl: "https://drive.google.com/file/d/sol-both/view",
    solutionDescription: "Custom solution title",
  },
];
